define('ordersDetailOrderProductAlternativesItemView',[
  'module',
  'marionette',
  'app',
  'underscore',
  'jquery',
  'settings',
  'bootbox',
  'template!ordersDetailOrderProductAlternativesItemView'
], function (
  Module,
  Marionette,
  App,
  _,
  $,
  Settings,
  bootbox,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-detail-order-product-alternatives-item-view',

    ui: {
      stockValue: '.alt-stock .metric-value',
      priceValue: '.alt-price .metric-value',
      stockLoading: '.alt-stock .metric-loading',
      priceLoading: '.alt-price .metric-loading',
      replaceBtn: '.js-replace-product',
      createOfferBtn: '.js-create-offer',
      actionLoading: '.action-loading',
      optionsSelects: '.alt-options-selects',
      printSelect: '.alt-print-select'
    },

    events: {
      'click @ui.replaceBtn': 'onReplaceProduct',
      'click @ui.createOfferBtn': 'onCreateOffer',
      'change .js-alt-option-select': 'onConfigChanged',
      'change .js-alt-print-select': 'onConfigChanged'
    },

    serializeData: function () {
      var data = this.model.toJSON();
      data.imageUrl = data.catalogPictureUid ?
        Settings.url('file', data.catalogPictureUid, {action: 'res', params: 't'}) : (data.catalogPictureUrl || null);
      return data;
    },

    onRender: function () {
      this.fetchStock();
      this.fetchAlternativeProduct();
    },

    fetchStock: function () {
      var productId = this.model.get('resellerProductId');
      if (!productId) return;
      var url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + productId + '/stocks');

      $.ajax({
        type: 'GET',
        url: url,
        success: _.bind(function (data) {
          if (this.isDestroyed) return;
          this.allStockData = data || [];
          this.updateStockDisplay();
        }, this),
        error: _.bind(function () {
          if (this.isDestroyed) return;
          this.allStockData = [];
          this.ui.stockValue.text('-');
          this.ui.stockLoading.hide();
          this.ui.stockValue.show();
        }, this)
      });
    },

    getSelectedOptionPimIds: function () {
      var pimIds = [];
      this.$('.js-alt-option-select').each(function () {
        var val = $(this).val();
        if (val) pimIds.push(val);
      });
      return pimIds;
    },

    findMatchingVariationCode: function () {
      var pimProduct = this.altPimProduct;
      if (!pimProduct || !pimProduct.data || !pimProduct.data.productCodeVariations) return null;

      var selectedPimIds = this.getSelectedOptionPimIds();
      if (selectedPimIds.length === 0) return null;

      var selectedSorted = selectedPimIds.slice().sort();

      var match = _.find(pimProduct.data.productCodeVariations, function (pcv) {
        if (!pcv.productOptions || pcv.productOptions.length === 0) return false;
        var variationPimIds = _.map(pcv.productOptions, function (po) { return po.pimId; }).sort();
        if (variationPimIds.length !== selectedSorted.length) return false;
        return _.every(selectedSorted, function (id, i) {
          return id === variationPimIds[i];
        });
      });

      return match ? match.code : null;
    },

    updateStockDisplay: function () {
      var variationCode = this.findMatchingVariationCode();
      var totalStock = 0;
      var found = false;

      if (this.allStockData && this.allStockData.length > 0 && variationCode) {
        var stockItem = _.find(this.allStockData, function (item) {
          return item.code === variationCode;
        });
        if (stockItem) {
          totalStock = stockItem.currentQuantity || 0;
          found = true;
        }
      }

      if (!found && this.allStockData && this.allStockData.length > 0 && !variationCode) {
        // No variation match possible (no options selected) — show total
        _.each(this.allStockData, function (item) {
          totalStock += (item.currentQuantity || 0);
        });
      }

      this.ui.stockValue.text(totalStock);
      this.ui.stockLoading.hide();
      this.ui.stockValue.show();
    },

    fetchAlternativeProduct: function () {
      var productId = this.model.get('productId');
      var resellerProductId = this.model.get('resellerProductId');
      if (!productId || !resellerProductId) return;

      var url = Settings.url('compuzz2', 'v2/pim/products/' + productId);

      $.ajax({
        type: 'GET',
        url: url,
        success: _.bind(function (pimProduct) {
          if (this.isDestroyed) return;
          this.altPimProduct = pimProduct;
          this.buildDropdowns();
          this.updateStockDisplay();
          this.fetchPrice();
        }, this),
        error: _.bind(function () {
          if (this.isDestroyed) return;
          this.ui.priceValue.text('-');
          this.ui.priceLoading.hide();
          this.ui.priceValue.show();
        }, this)
      });
    },

    getOptionName: function (opt) {
      if (opt.name) {
        if (typeof opt.name === 'string') return opt.name;
        var values = opt.name.values || opt.name;
        if (typeof values === 'string') return values;
        if (values.en) return values.en;
        if (values.EN) return values.EN;
        for (var lang in values) {
          if (values.hasOwnProperty(lang) && typeof values[lang] === 'string' && values[lang]) return values[lang];
        }
      }
      return opt.code || opt.pimId || '';
    },

    buildDropdowns: function () {
      var pimProduct = this.altPimProduct;
      if (!pimProduct || !pimProduct.data) return;

      this.buildOptionsDropdowns(pimProduct.data);
      this.buildPrintDropdown(pimProduct.data);
    },

    getOrderOptions: function () {
      var orderOptions = this.options.orderModel.get('options') || [];
      var optionsMix = this.options.orderModel.get('optionsMix') || [];

      // optionsMix entries each have their own 'options' array
      _.each(optionsMix, function (mix) {
        if (mix.options) {
          _.each(mix.options, function (opt) {
            orderOptions.push(opt);
          });
        }
      });

      return orderOptions;
    },

    getOptionEnName: function (opt) {
      if (opt.name) {
        if (typeof opt.name === 'string') return opt.name;
        var values = opt.name.values || opt.name;
        if (typeof values === 'string') return values;
        if (values.en) return values.en;
        if (values.EN) return values.EN;
      }
      return '';
    },

    findMatchingOrderOption: function (altCatName, altOptions) {
      var orderOptions = this.getOrderOptions();
      if (!orderOptions || orderOptions.length === 0) return null;

      // Get the en name for the alt category
      var altCatEnName = altCatName.toLowerCase();

      // Find order option whose supplierCatNameDt.en matches this alt category (en)
      var matchingOrderOpt = _.find(orderOptions, function (oo) {
        var supplierCatName = '';
        if (oo.supplierCatNameDt && oo.supplierCatNameDt.values && oo.supplierCatNameDt.values.en) {
          supplierCatName = oo.supplierCatNameDt.values.en.toLowerCase();
        }
        return supplierCatName && altCatEnName && supplierCatName === altCatEnName;
      });

      // Fallback to categoryName if supplierCatNameDt didn't match
      if (!matchingOrderOpt) {
        matchingOrderOpt = _.find(orderOptions, function (oo) {
          return oo.categoryName && altCatEnName &&
            oo.categoryName.toLowerCase() === altCatEnName;
        });
      }

      if (!matchingOrderOpt) return null;

      var orderOptName = '';
      if (matchingOrderOpt.supplierNameDt && matchingOrderOpt.supplierNameDt.values && matchingOrderOpt.supplierNameDt.values.en) {
        orderOptName = matchingOrderOpt.supplierNameDt.values.en.toLowerCase();
      }
      if (!orderOptName) {
        orderOptName = (matchingOrderOpt.name || '').toLowerCase();
      }
      var orderOptCode = (matchingOrderOpt.code || '').toLowerCase();

      var matched = null;

      // Match by code first
      _.each(altOptions, function (opt) {
        if (matched) return;
        var altCode = (opt.code || '').toLowerCase();
        if (orderOptCode && altCode && orderOptCode === altCode) {
          matched = opt.pimId;
        }
      });

      // Exact match on en name
      if (!matched) {
        _.each(altOptions, _.bind(function (opt) {
          if (matched) return;
          var altEnName = this.getOptionEnName(opt).toLowerCase();
          if (orderOptName && altEnName && orderOptName === altEnName) {
            matched = opt.pimId;
          }
        }, this));
      }

      // Partial match on en name
      if (!matched) {
        _.each(altOptions, _.bind(function (opt) {
          if (matched) return;
          var altEnName = this.getOptionEnName(opt).toLowerCase();
          if (orderOptName && altEnName && (altEnName.indexOf(orderOptName) !== -1 || orderOptName.indexOf(altEnName) !== -1)) {
            matched = opt.pimId;
          }
        }, this));
      }

      return matched;
    },

    buildOptionsDropdowns: function (data) {
      var container = this.ui.optionsSelects;
      container.empty();

      if (!data.productOptionCategories || data.productOptionCategories.length === 0) return;

      _.each(data.productOptionCategories, _.bind(function (cat) {
        if (!cat.productOptions || cat.productOptions.length === 0) return;

        var catEnName = this.getOptionEnName(cat) || this.getOptionName(cat);
        var catDisplayName = this.getOptionName(cat);
        var select = $('<select class="form-control input-sm js-alt-option-select" data-cat-pim-id="' + cat.pimId + '"></select>');

        _.each(cat.productOptions, _.bind(function (opt) {
          var optName = this.getOptionName(opt);
          select.append($('<option></option>').val(opt.pimId).text(optName));
        }, this));

        // Pre-select matching option from current order (based on en name)
        var matchedPimId = this.findMatchingOrderOption(catEnName, cat.productOptions);
        if (matchedPimId) {
          select.val(matchedPimId);
        }

        var wrapper = $('<div class="alt-option-group"></div>');
        wrapper.append($('<label class="alt-option-label"></label>').text(catDisplayName));
        wrapper.append(select);
        container.append(wrapper);
      }, this));
    },

    buildPrintDropdown: function (data) {
      var container = this.ui.printSelect;
      container.empty();

      if (!data.printAreas || data.printAreas.length === 0) return;

      var orderColors = this.getOrderColorsByZone();
      var select = $('<select class="form-control input-sm js-alt-print-select"></select>');
      select.append($('<option value=""></option>').text('-- ' + _.i18n('common.none') + ' --'));

      var zoneIndex = 0;
      _.each(data.printAreas, _.bind(function (pa) {
        if (!pa.printZones || pa.printZones.length === 0) return;

        var paName = this.getOptionName(pa);
        var optgroup = $('<optgroup></optgroup>').attr('label', paName);

        _.each(pa.printZones, _.bind(function (pz) {
          var itName = '';
          if (pz.refImprintTechnology) {
            itName = this.getOptionName(pz.refImprintTechnology);
            if (!itName) itName = pz.refImprintTechnology.code || '';
          }
          var defaultColors = orderColors.length > zoneIndex ? orderColors[zoneIndex] : 1;
          var label = itName + ' (' + defaultColors + ' col.)';
          optgroup.append($('<option></option>').val(pz.pimId).attr('data-colors', defaultColors).text(label));
          zoneIndex++;
        }, this));

        select.append(optgroup);
      }, this));

      if (zoneIndex > 0) {
        // Pre-select matching zones based on order config
        this.preselectPrintZones(select, data, orderColors);
        var wrapper = $('<div class="alt-option-group"></div>');
        wrapper.append($('<label class="alt-option-label"></label>').text(_.i18n('common.print')));
        wrapper.append(select);
        container.append(wrapper);
      }
    },

    preselectPrintZones: function (select, data, orderColors) {
      // Select first zone by default if order has print
      if (orderColors.length > 0) {
        var firstPz = null;
        _.each(data.printAreas, function (pa) {
          if (!firstPz && pa.printZones && pa.printZones.length > 0) {
            firstPz = pa.printZones[0];
          }
        });
        if (firstPz) {
          select.val(firstPz.pimId);
        }
      }
    },

    getOrderColorsByZone: function () {
      var colorsPerZone = [];
      var compositions = this.options.orderModel.get('compositions');
      if (compositions && compositions.length > 0) {
        _.each(compositions, function (comp) {
          var nbrColors = comp.nbrColors || 0;
          if (nbrColors === 0 && comp.usedColors) {
            nbrColors = comp.usedColors.length;
          }
          if (nbrColors > 0) {
            colorsPerZone.push(nbrColors);
          }
        });
      }
      return colorsPerZone;
    },

    getSelectedOptions: function () {
      var options = [];
      this.$('.js-alt-option-select').each(function () {
        var val = $(this).val();
        if (val) options.push(val);
      });
      return options;
    },

    getSelectedPrintConfig: function () {
      var printZonesColors = {};
      var selectedPz = this.$('.js-alt-print-select').val();
      if (selectedPz) {
        var selectedOption = this.$('.js-alt-print-select option:selected');
        var colors = parseInt(selectedOption.attr('data-colors'), 10) || 1;
        printZonesColors[selectedPz] = colors;
      }
      return printZonesColors;
    },

    onConfigChanged: function () {
      this.ui.priceValue.hide();
      this.ui.priceLoading.show();
      this.fetchPrice();
      this.updateStockDisplay();
    },

    fetchPrice: function () {
      var resellerProductId = this.model.get('resellerProductId');
      if (!resellerProductId) return;
      var quantity = this.options.orderModel.get('quantity') || 1;
      var url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + resellerProductId + '/configuration/price');

      var config = {
        quantity: quantity,
        options: this.getSelectedOptions(),
        optionsMix: [],
        printZonesColors: this.getSelectedPrintConfig()
      };

      $.ajax({
        type: 'POST',
        url: url,
        contentType: 'application/json',
        data: JSON.stringify(config),
        success: _.bind(function (priceData) {
          if (this.isDestroyed) return;
          var totalPrice = '-';
          if (priceData && priceData.total !== null && priceData.total !== undefined) {
            totalPrice = parseFloat(priceData.total).toFixed(2) + ' \u20AC';
          } else if (priceData && priceData.scale && priceData.scale.length > 0) {
            var matched = _.find(priceData.scale, function (s) {
              return parseInt(s.quantity, 10) >= quantity;
            });
            if (!matched) matched = priceData.scale[priceData.scale.length - 1];
            if (matched && matched.total !== null && matched.total !== undefined) {
              totalPrice = parseFloat(matched.total).toFixed(2) + ' \u20AC';
            }
          }
          this.ui.priceValue.text(totalPrice);
          this.ui.priceLoading.hide();
          this.ui.priceValue.show();
        }, this),
        error: _.bind(function () {
          if (this.isDestroyed) return;
          this.ui.priceValue.text('-');
          this.ui.priceLoading.hide();
          this.ui.priceValue.show();
        }, this)
      });
    },

    buildPrintConfigForReplace: function () {
      return this.getSelectedPrintConfig();
    },

    showActionLoading: function () {
      this.ui.replaceBtn.hide();
      this.ui.createOfferBtn.hide();
      this.ui.actionLoading.show();
    },

    hideActionLoading: function () {
      this.ui.actionLoading.hide();
      this.ui.replaceBtn.show();
      this.ui.createOfferBtn.show();
    },

    buildConfigForRequest: function () {
      var printZonesColors = this.getSelectedPrintConfig();
      var quantity = this.options.orderModel.get('quantity') || 1;
      var selectedOptions = this.getSelectedOptions();

      var options = {};
      _.each(selectedOptions, function (pimId, i) {
        options[i] = pimId;
      });

      var printZones = {};
      var idx = 0;
      _.each(printZonesColors, function (nbrColor, pzId) {
        printZones[idx] = {pzId: pzId, nbrColor: nbrColor};
        idx++;
      });

      return {
        quantity: quantity,
        options: options,
        optionsMix: [],
        printZones: printZones
      };
    },

    onReplaceProduct: function () {
      var productCode = this.model.get('productCode');
      bootbox.confirm(_.i18n('product.confirmReplaceWithAlternative') + ' (' + productCode + ')?', _.bind(function (result) {
        if (result) {
          this.showActionLoading();

          var productId = this.model.get('productId');
          var orderModel = this.options.orderModel;
          var purchaseOrderId = orderModel.get('purchaseOrderId');
          var changeUrl = Settings.url('compuzz2', 'commands.json/' + purchaseOrderId + '/product/pim', {
            productSecId: productId
          });

          $.ajax({
            method: 'PUT',
            url: changeUrl,
            success: _.bind(function () {
              var printZonesColors = this.buildPrintConfigForReplace();
              var quantity = orderModel.get('quantity') || 1;

              var printZones = {};
              var idx = 0;
              _.each(printZonesColors, function (nbrColor, pzId) {
                printZones[idx] = {pzId: pzId, nbrColor: nbrColor};
                idx++;
              });

              var configuration = {
                quantity: quantity,
                options: {},
                optionsMix: [],
                printZones: printZones
              };

              var selectedOptions = this.getSelectedOptions();
              _.each(selectedOptions, function (optPimId, i) {
                configuration.options[i] = optPimId;
              });

              App.request('order:update-from-configuration-pim', purchaseOrderId, configuration).then(function () {
                orderModel.fetch();
              });
            }, this),
            error: _.bind(function () {
              if (this.isDestroyed) return;
              this.hideActionLoading();
            }, this)
          });
        }
      }, this));
    },

    onCreateOffer: function () {
      var productCode = this.model.get('productCode');
      bootbox.confirm(_.i18n('product.confirmCreateOfferFromAlternative') + ' (' + productCode + ')?', _.bind(function (result) {
        if (result) {
          this.showActionLoading();
          var resellerProductCode = this.model.get('resellerProductCode');
          var orderModel = this.options.orderModel;
          var endUserId = orderModel.get('endUserId') || '';
          var customerId = orderModel.get('customerId') || '';
          var config = this.buildConfigForRequest();

          App.request('kanban:create-from-configuration-pim', 'offer', resellerProductCode, endUserId, customerId, config)
            .done(_.bind(function (poi) {
              if (this.isDestroyed) return;
              this.hideActionLoading();
              if (poi && poi.value) {
                App.navigate('orders/' + poi.value, {trigger: true});
              }
            }, this))
            .fail(_.bind(function () {
              if (this.isDestroyed) return;
              this.hideActionLoading();
            }, this));
        }
      }, this));
    }
  });
});

